module.exports = __webpack_public_path__ + "static/profile-jacqui-sabo-f4c95704f50503abe1871f8e7aed393e.png";